import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { logoutUser } from '../redux/actions/userActions';

class Common extends Component {
    handleLogout = () => {
        this.props.logoutUser(this.props.history);
        return <Redirect to='/login' />
    }
    render() {
        const {
            isCategories,
            isPosts,
            isAddPost,
            isStaffs,
            isFilter, 
            user: {
                credentials: {
                    rootActive
                }
            } 
        } = this.props;
        return (
            <div className="bg-light pt-15 pb-15 header-sticky">
                <div className="category-icon-list">
                    <Link className={`box ${(isPosts || isAddPost) ? 'active' : ''}`} to="/bai-viet">
                        <div>
                            <i className="fal fa-newspaper" />
                            <h4>Quản lý<br />Bài viết</h4>
                        </div>
                    </Link>
                    <Link className={`box ${isCategories ? 'active' : ''}`} to="/bai-viet/danh-muc">
                        <div>
                            <i className="fal fa-list-alt" />
                            <h4>Quản lý<br />Danh mục</h4>
                        </div>
                    </Link>
                    {rootActive &&
                    <Link className={`box ${isStaffs ? 'active' : ''}`} to="/nhan-su">
                        <div>
                            <i className="fal fa-user-tie" />
                            <h4>Quản lý<br />Nhân sự</h4>
                        </div>
                    </Link>
                    }
                    <div className="box" style={{verticalAlign: 'top'}} onClick={this.handleLogout}>
                        <div>
                            <i className="fal fa-sign-out" />
                            <h4>Đăng xuất<br />Tài khoản</h4>
                        </div>
                    </div>
                </div>
                {isPosts &&
                    <div className={`box-has-icon filter ${isFilter ? 'active events' : ''}`} onClick={() => this.props.openFilter(!isFilter)}>
                        <div>
                            <i className="fal fa-filter" />
                        </div>
                    </div>
                }
                {/* {isCategories &&
                    <Link className="box-has-icon filter" to="/bai-viet">
                        <div>
                            <i className="fal fa-arrow-from-right" />
                        </div>
                    </Link>
                } */}
                {isPosts &&
                    <Link className="box-has-icon add" to="/bai-viet/them-moi">
                        <div>
                            <i className="fal fa-plus" />
                        </div>
                    </Link>
                }
                {isCategories &&
                    <Link className="box-has-icon add" to="/bai-viet/danh-muc/them-moi">
                        <div>
                            <i className="fal fa-plus" />
                        </div>
                    </Link>
                }
                {(isStaffs) &&
                    <div className="box-has-icon add" onClick={() => this.props.toggleleBoxAdd()}>
                        <div>
                            <i className="fal fa-plus" />
                        </div>
                    </div>
                }
            </div>
        )
    }
}

Common.propTypes = {
    user: PropTypes.object.isRequired,
    logoutUser: PropTypes.func.isRequired,
  }
  
const mapStateToProps = state => ({
    user: state.user,
})

export default connect(mapStateToProps, { logoutUser })(Common);
